module.exports = __webpack_public_path__ + "static/media/memvra-1.7dfef8b9.png";